export default angular
  .module("PublishedVersionsModalCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
    "diff-match-patch",
  ])
  .controller("PublishedVersionsModalController", [
    "$rootScope",
    "$scope",
    "$modalInstance",
    "Scripts",
    "publishedVersions",
    "version",
    "selectedScriptId",
    function (
      $rootScope,
      $scope,
      $modalInstance,
      Scripts,
      publishedVersions,
      version,
      selectedScriptId,
      hide,
    ) {
      $scope.hide = hide
      $scope.paginationSize = 5;
      $scope.version = version;
      $scope.publishedVersions = publishedVersions;
      $scope.versionToDiff = publishedVersions
        .filter(el => el.ID !== version.ID)
        .pop();

      $scope.isCurrentSavedVersion = false;
      $scope.currentSavedVersion = {};
      Scripts.loadScriptJSByID(selectedScriptId, (data) => {
        $scope.currentSavedVersion = data;
      });

      $scope.handleDiff = (versionToDiff, isCurrentSavedVersion = false) => {
        $scope.versionToDiff = versionToDiff;
        $scope.isCurrentSavedVersion = isCurrentSavedVersion;
      };

      $scope.diffOptions = { editCost: 4 };

      $scope.close = () =>
        $modalInstance
          .close({ action: "close", payload: "Closing version details" });
    },
  ]);
